import React from 'react';
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import image from './images/announcement-2.webp';

const Image = () => {
    return (
        <Box>
            <Box
                component={CardMedia}
                borderRadius={2}
                width={'100%'}
                height={'auto'}
                paddingBottom={'75%'} // Set the aspect ratio, for example, 75% for a 4:3 aspect ratio
                position="relative"
            >
                <img
                    src={image}
                    alt="Your Image"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    }}
                />
            </Box>
        </Box>
    );
};

export default Image;
